import RibbonsContainer from "../../components/bonusUi/ribbons";

const Ribbons = () => {
  return <RibbonsContainer />;
};

export default Ribbons;
